module.exports = __webpack_public_path__ + "fd05344dd846a3556beb04e9ed153eae.svg";